// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rke-template[data-v-1471a8a9]{align-items:center;display:inline-flex}.rke-template .template-upgrade-icon[data-v-1471a8a9]{border:1px solid var(--warning);border-radius:50%;color:var(--warning);margin-left:4px;font-size:14px;padding:2px}", ""]);
// Exports
module.exports = exports;
